import React from 'react';
import ReactDOM from 'react-dom';
import { setDefaultEnv } from '@cld/env-config';
import envInfoLabel from '@cld/env-info-label';
import App from './App';
import { getEnvFromHostname } from './services/EnvData';

// set env from hostname, must be called before other usage
setDefaultEnv(getEnvFromHostname());
envInfoLabel();

ReactDOM.render(<App />, document.getElementById('standalone'));
